import {countUp} from "../../default/global/js/countUp";

export function initItemcardNavigation() {

        initTabFunctions(document.querySelector('.itemcard'));

        const options = {
            rootMargin: "-20% 0px -85% 0px"
        };
        initNavigationScrollSpy(document.querySelectorAll('.js-scrollSpyElement'), options);

        if (window.innerWidth > 767) {
           initNavigationSticky();
        }


}

function initNavigationSticky() {
    const nav = document.querySelector(".itemcardNavigation__nav");
    const footer = document.querySelector('footer');
    const itemcard = document.querySelector('.itemcard');

    if (!nav || !footer || !itemcard) return;

    function adjustFixedNavigation() {
        const scrollY = window.scrollY || window.pageYOffset;
        const viewportHeight = window.innerHeight;
        const navHeight = nav.offsetHeight;
        const footerTop = footer.offsetTop;
        const itemcardTop = itemcard.offsetTop;

        const navCenterPosition = scrollY + (viewportHeight / 2);
        const navTop = navCenterPosition - (navHeight / 2);
        const navBottom = navCenterPosition + (navHeight / 2);

        nav.style.transform = 'translateY(-50%)';

        let additionalOffset = 0;

        if (navTop < itemcardTop + 30) {
            const topOverlap = (itemcardTop + 30) - navTop;
            additionalOffset = topOverlap;
        }

        if (navBottom >= footerTop - 30) {
            const bottomOverlap = navBottom - (footerTop - 30);
            additionalOffset = -bottomOverlap;
        }

        if (additionalOffset !== 0) {
            nav.style.transform = `translateY(-50%) translateY(${additionalOffset}px)`;
        }
    }

    adjustFixedNavigation();
    window.addEventListener('scroll', adjustFixedNavigation);
    window.addEventListener('resize', adjustFixedNavigation);
}



function initNavigationScrollSpy(animationElements,options) {


    const animationObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {

                for (let item of document.querySelector('.itemcardNavigation__nav').querySelectorAll('a')) {
                    item.classList.remove('is-active');

                    if(item.getAttribute("href") === '#'+entry.target.getAttribute("id")) {
                        item.classList.add('is-active');
                    }
                }

            }
        });
    }, options);

    animationElements.forEach(function (animateElement) {
        animationObserver.observe(animateElement);
    });

}


function initTabFunctions(itemcardContainer) {

    const tabNavigation = itemcardContainer.querySelectorAll('.itemcardNavigation__nav li a');
    const tabContents = itemcardContainer.querySelectorAll('.contentTabItem');

    if (!tabContents.length) {
        return false;
    }

    tabContents[0].classList.add('is-active');
    tabNavigation[0].classList.add('is-active');


    for (let link of tabNavigation) {

        link.addEventListener('click', (e) => {

            e.preventDefault();

            removeAllActiveStates(tabNavigation, tabContents);
            link.classList.add('is-active');

            let target = link.dataset.target;

            for (let container of tabContents) {

                if(container.dataset.tab === target) {
                    container.classList.add('is-active');
                }

            }

        });

    }

}

function removeAllActiveStates(tabNavigation, tabContents) {

    for (let link of tabNavigation) {
        link.classList.remove('is-active');
    }

    for (let item of tabContents) {
        item.classList.remove('is-active');
    }

}